import currencies from './currencies.json';

const worldCurrencies = currencies;

export default worldCurrencies;
